import { useEffect } from 'react';

import { Flex, Box } from '@chakra-ui/react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@mesh.ai/rabbit';
import { useGetViolationTypes } from 'Deer/pages/MyData/DisciplinaryActions/dataHooks';
import { useDispatch } from 'react-redux';

import { TextLabel } from 'uiToolkitV1/Typography';

import { updateAddViolationDrawer, useSelectAddViolationDrawerData } from '../slice/addViolation.slice';

const ViolationTypeDropdown = () => {
  const { type } = useSelectAddViolationDrawerData();
  const { data: violationTypesData } = useGetViolationTypes();
  const { noteTypes = [] } = violationTypesData ?? {};
  const dispatch = useDispatch();

  const handleViolationTypeChange = (value: string) => {
    dispatch(
      updateAddViolationDrawer({
        type: value,
      })
    );
  };

  useEffect(() => {
    if (noteTypes.length > 0) {
      dispatch(updateAddViolationDrawer({ type: noteTypes[0] }));
    }
  }, [noteTypes, dispatch]);

  return (
    <Flex flexDir="column" alignItems="flex-start">
      <TextLabel color="text.g2">Type</TextLabel>
      <Box w="100%">
        <Select value={type || ''} onValueChange={handleViolationTypeChange}>
          <SelectTrigger style={{ width: '100%', textAlign: 'left' }}>
            <SelectValue placeholder="Select Violation Type" />
          </SelectTrigger>
          <SelectContent style={{ maxWidth: '100%' }}>
            <SelectGroup>
              {noteTypes.map((option) => (
                <SelectItem key={option} value={option}>
                  {option}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </Box>
    </Flex>
  );
};

export { ViolationTypeDropdown };
